/*
 * @Description: s售后服务
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
/*
 * @Description: 报价单相关路由
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-21 14:24:58
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const SALESSERVICE = {
  path: '/service',
  name: 'service',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'service-list' },
  meta: {
    title: '售后服务',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'afterSale',
    order: 4
  },
  children: [
    {
      path: 'index',
      name: 'service-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'service-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'afterSale:view',
        title: '售后服务'
      },
      children: [
        {
          path: '',
          name: 'service-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 12 },
          meta: {
            requiresAuth: true,
            roles: 'afterSale:view',
            title: '售后服务'
          }
        },
        {
          path: ':id/collaborators',
          name: 'sales-service-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 12 },
          meta: {
            requiresAuth: true,
            roles: 'afterSale:view',
            title: '售后服务详情'
          }
        },
        {
          path: ':id',
          name: 'sales-service-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 12 },
          meta: {
            requiresAuth: true,
            roles: 'afterSale:view',
            title: '售后服务详情'
          }
        }
      ]
    }
  ]
};

export default SALESSERVICE;
